export const ENDPOINTS = {
  CUSTOMER_FILE: {
    byId: (fileId, cache = false) =>
      'estimates/customerFiles/{fileId}'.replace('{fileId}', fileId) +
      (cache ? '?cache=true' : ''),
    accident: (fileId) =>
      'estimates/customerFiles/{fileId}/accident'.replace('{fileId}', fileId),
  },
  ESTIMATE: {
    byId: (fileId, estimateId) =>
      'estimates/customerFiles/{fileId}/estimates/{estimateId}'
        .replace('{fileId}', fileId)
        .replace('{estimateId}', estimateId),
    create: (fileId) =>
      'estimates/customerFiles/{fileId}/estimates'.replace('{fileId}', fileId),
  },
  INVENTORY: {
    image: (fileId, inspectionType, inventoryId) =>
      'estimates/customerFiles/{fileId}/inspection/{inspectionType}/inventory/{inventoryId}/image'
        .replace('{fileId}', fileId)
        .replace('{inspectionType}', inspectionType)
        .replace('{inventoryId}', inventoryId),
  },
  VEHICLE_PROPS: {
    byId: (fileId) =>
      'estimates/customerFiles/{fileId}/vehicle'.replace('{fileId}', fileId),
  },
  PROCEDURES: {
    byCartId: (cartId) =>
      'estimates/carts/{cartId}/beneficiaries/repair/procedures'.replace(
        '{cartId}',
        cartId,
      ),
    update: (cartId) =>
      'estimates/carts/{cartId}/beneficiaries/repair'.replace(
        '{cartId}',
        cartId,
      ),
    byEstimateId: (estimateId) =>
      'estimates/estimates/{estimateId}/procedures'.replace(
        '{estimateId}',
        estimateId,
      ),
  },
  CART: {
    byId: (cartId) => `estimates/carts/${cartId}`,
    byEstimateId: (cartId, estimateId) =>
      `estimates/carts/${cartId}/estimates/${estimateId}`,
    items: (cartId) => `estimates/carts/${cartId}/items`,
    itemById: (cartId, itemId) => `estimates/carts/${cartId}/items/${itemId}`,
    recommendedParts: (cartId) => `estimates/carts/${cartId}/recommendedParts`,
    rates: (cartId) => `estimates/carts/${cartId}/rates`,
    laborSearch: (cartId) => `estimates/carts/${cartId}/laborsearch`,
    laborList: (cartId) => `estimates/carts/${cartId}/laborlist`,
    itemsBulk: (cartId) => `estimates/carts/${cartId}/items/bulk`,
    itemsItemLabor: (cartId, itemId) =>
      `estimates/carts/${cartId}/items/${itemId}/labor`,
    partPartLabor: (cartId, partId) =>
      `estimates/carts/${cartId}/part/${partId}/labor`,
    kits: (cartId) => `estimates/carts/${cartId}/kits`,
    kitsKitId: (cartId, kitId) => `estimates/carts/${cartId}/kits/${kitId}`,
    additions: (cartId) => `estimates/carts/${cartId}/additions`,
    additionsById: (cartId, additionId) =>
      `estimates/carts/${cartId}/additions/${additionId}`,
  },
  DOC: {
    getById: (docId) => `estimates/docs/${docId}`,
    deleteImage: (docId, imageId) => `estimates/docs/${docId}/image/${imageId}`,
    uploadImage: (docId) => `estimates/docs/${docId}/image`,
    updateImage: (docId, imageId) => `estimates/docs/${docId}/image/${imageId}`,
    addDamageArea: (docId) => `estimates/docs/${docId}/damages`,
  },
}

// Auth
export const LOGIN_PATH = 'estimates/auth/login'
export const REPORT_ERROR_PATH = 'Auth/errorreport'
export const REFRESH_TOKEN_PATH = 'estimates/auth/refreshtoken'
export const SOCKET_GET_URL_PATH = 'websocket/uri'
export const ENTITY_TABLE = 'estimates/tables/entities'
export const THEME_PATH = 'estimates/themes/{themeId}'

// Catalog
export const MULTI_SEARCH_PARTS_PATH = 'multi-search'
export const PART_PRICES_BY_CATALOG_PATH =
  'Cart/{cartId}/parts/prices/{catalogNumber}'

// Model
export const MODEL_IDENTIFICATION_PATH = 'model-identification'

// ACCIDENTS
export const ACCIDENTS_REPORT_PATH = 'estimates/accidents/{tokenId}/report'
export const ACCIDENTS_IMAGE_PATH = 'accidents/{tokenId}/image'
export const ACCIDENTS_TABLES_INSURERS_PATH =
  'accidents/{tokenId}/tables/insurers'

//DOCS
export const DOCS_DAMAGE_PATH = 'estimates/docs/{docId}/damages'
export const DOCS_ATTACHMENTS_PATH = '/estimates/docs/{docId}/attachments'
export const DOCS_UPDATE_ATTACHMENTS =
  '/estimates/docs/{docId}/attachments/{imageId}'
export const DOCS_PRINT_OPTIONS = '/estimates/docs/{docId}/printoptions'
export const DOCS_REPORT_PATH = '/estimates/docs/{docId}/report'
export const DOCS_EVENT_PATH = '/estimates/docs/{docId}/event/{eventId}'
//ESTIMATES
export const ESTIMATES_CREATE_CUSTOMER_FILE_PATH = 'estimates/customerfiles'
export const ESTIMATES_CUSTOMER_FILES_PATH = 'estimates/customerfiles/v2'
export const ESTIMATES_CUSTOMER_FILES_STAGES_PATH =
  'estimates/customerfiles/stages/v2'

export const ESTIMATES_DOCUMENT_IMAGE_PATH = 'estimates/docs/{docId}/image'
export const ESTIMATES_DOCUMENT_IMAGE_SVG_PATH =
  'estimates/docs/{docId}/image/{imageId}/svg?width={width}&height={height}'
export const ESTIMATES_DOCUMENT_SIGNATURE_PATH =
  'estimates/docs/{docId}/signature/{num}'
export const ESTIMATES_DOCUMENT_SHARE_PATH = 'estimates/docs/{docId}/share'
export const RESET_PASSWORD_REQUEST = 'estimates/auth/resetpassword/request'
export const RESET_PASSWORD = 'estimates/auth/resetpassword/set'
export const VERIFY_ACCOUNT = 'estimates/auth/verifyuser/set'
export const GET_DOC_TOKEN = 'estimates/auth/doctoken/{tokenId}'

//SERVICE-STATUS
export const ESTIMATES_ACCIDENT_REPORT =
  'estimates/customerfiles/{fileId}/accident/request'
export const SERVICE_STATUS_PATH =
  'estimates/customerfiles/{fileId}/flow/{flowId}'
export const ESTIMATES_CUSTOMER_FILE_AUDIT_PATH =
  'estimates/customerFiles/{fileId}/audit'
export const ESTIMATES_CUSTOMER_FILE_AUDIT_ITEM_PATH =
  'estimates/customerFiles/{fileId}/audit/{threadId}'
export const ESTIMATES_CUSTOMER_AUTO_SHARE =
  'estimates/customerfiles/{fileId}/estimates/auto'

// INSPECTION (Reception / HandOver are inspection types)
export const ESTIMATES_CUSTOMER_FILE_INSPECTION_DAMAGE_MARKING_PATH =
  'estimates/customerfiles/{fileId}/inspection/{inspectionType}/damagemarking' +
  '?picture={picture}&width={width}&height={height}'
export const ESTIMATES_CUSTOMER_FILE_INSPECTION_INTERNAL_DAMAGE_MARKING_PATH =
  'estimates/customerfiles/{fileId}/inspection/{inspectionType}/damagemarking/internal' +
  '?picture={picture}&width={width}&height={height}'
export const ESTIMATES_CUSTOMER_FILE_INSPECTION_INVENTORY_PATH =
  'estimates/customerfiles/{fileId}/inspection/{inspectionType}/inventory/{inventoryId}'
export const ESTIMATES_CUSTOMER_FILE_INSPECTION_NEW_INVENTORY_PATH =
  'estimates/customerfiles/{fileId}/inspection/{inspectionType}/inventory'
export const ESTIMATES_CUSTOMER_FILE_INSPECTION_INVENTORY_BULK_PATH =
  'estimates/customerfiles/{fileId}/inspection/{inspectionType}/inventory/bulk'
export const ESTIMATES_CUSTOMER_FILE_INSPECTION_INVENTORY_IMAGE_PATH =
  'estimates/customerfiles/{fileId}/inspection/{inspectionType}/inventory/{inventoryId}/image'

export const ESTIMATES_TABLES_SERVICE_TYPES_PATH = 'estimates/tables/subTypes'
export const ESTIMATES_TABLES_CURRENCY_TABLES =
  'estimates/tables/currencytables'

export const ESTIMATES_VEHICLE_PROPS_PATH =
  'estimates/customerfiles/{fileId}/vehicle'

export const ESTIMATES_TABLES_INSURERS = 'estimates/tables/insurers'
export const ESTIMATES_TABLES_REPAIRERS = 'estimates/tables/repairers'
export const ESTIMATES_TABLES_EXPERTS = 'estimates/tables/experts'
export const ESTIMATES_TABLES_TOTAL_ENTITIES = 'estimates/tables/entities'
export const ESTIMATES_TABLES_SUPPLIERS = 'estimates/tables/suppliers'
export const ESTIMATES_TABLES_INSPECTORS = 'estimates/tables/inspectors'
export const ESTIMATES_TABLES_CLAIM_SERVICE_PROVIDERS =
  'estimates/tables/claimserviceproviders'

//ESTIMATE-CARTS
export const ESTIMATES_CART_LABOR_SEARCH_PATH =
  'estimates/carts/{cartId}/laborsearch'
export const ESTIMATES_PROCEDURES_PATH =
  'estimates/carts/{cartId}/beneficiaries/repair/procedures'
export const ESTIMATES_POST_PROCEDURES_PATH =
  'estimates/carts/{cartId}/beneficiaries/repair'
export const ESTIMATES_UPDATE_ENTITY = 'estimates/customerfiles/{fileId}'
export const ESTIMATES_CART_PATH = 'estimates/carts/{cartId}'
export const ESTIMATES_CART_ITEMS_PATH = 'estimates/carts/{cartId}/items'
export const ESTIMATES_CART_RATES_PATH = 'estimates/carts/{cartId}/rates'
export const ESTIMATES_MULIT_CART_ITEMS_PATH =
  'estimates/carts/{cartId}/items/bulk'
export const ESTIMATES_CART_ITEM_LABOR_PATH =
  'estimates/carts/{cartId}/items/{itemId}/labor'
export const ESTIMATES_CART_PART_LABOR_PATH =
  'estimates/carts/{cartId}/part/{partId}/labor'
export const ESTIMATES_CUSTOMER_FILES_ESTIMATES_PATH =
  'estimates/customerfiles/{fileId}/estimates/{estimateId}'
export const ESTIMATES_CUSTOMER_FILES_NEW_ESTIMATE_PATH =
  'estimates/customerfiles/{fileId}/estimates'
export const ESTIMATES_CUSTOMER_FILE_SHARE =
  'estimates/customerfiles/{fileId}/estimates/{estimateId}'
export const UPLOAD_PHOTOS_TO_AI = 'aiImages/upload-async/{fileId}'
export const ESTIMATES_CUSTOMER_FILE_CLICK_INS_GET_STATUS =
  'aiImages/status/{fileId}'
export const CART_PRICES_PATH =
  'Cart/{cartId}/parts/{partId}/prices/{catalogNumber}'

// AUDIT
export const ESTIMATES_AUDIT_PATH = 'estimates/customerfiles/{fileId}/audit'
export const ESTIMATES_AUDIT_ITEM_PATH =
  'estimates/customerfiles/{fileId}/audit/{threadId}'

// SERVICE-BOOKING
export const SERVICE_BOOKING_BASE_PATH = 'serviceBooking'
export const SERVICE_BOOKING_CREATE_PATH = 'serviceBooking/create'
export const SERVICE_BOOKING_VERIFY_CODE_PATH =
  'serviceBooking/{tokenId}?verifyCode={verifyCode}'
export const SERVICE_BOOKING_PATH = 'serviceBooking/{tokenId}'
export const SERVICE_BOOKING_SEARCH_PATH = 'serviceBooking/{tokenId}/lookup'
export const SERVICE_BOOKING_CONFIRM_PATH = 'serviceBooking/{tokenId}/confirm'
export const SERVICE_BOOKING_TABLES_AREAS_PATH =
  'serviceBooking/{tokenId}/tables/areas'
export const SERVICE_BOOKING_TABLES_REPAIR_TYPES_PATH =
  'serviceBooking/{tokenId}/tables/repairTypes'
export const SERVICE_BOOKING_TABLES_RESCHEDULE_REASONS_PATH =
  'serviceBooking/{tokenId}/tables/reschedulereasons'
export const SERVICE_BOOKING_TABLES_CANCEL_REASONS_PATH =
  'serviceBooking/{tokenId}/tables/cancelreasons'
export const SERVICE_BOOKING_FLEET_PATH = 'serviceBooking/fleet/{appPath}'
export const SERVICE_BOOKING_IMAGE_PATH = 'serviceBooking/{tokenId}/image'

//External application commands
export const APP_CMD_OPEN_CAMERA_PATH =
  'appcmd://camera?fileid={fileId}&token={jwtToken}&damageId={damageId}&modal={modal}'
export const APP_CMD_OPEN_LIBRARY_PATH =
  'appcmd://library?fileid={fileId}&token={jwtToken}&damageId={damageId}&modal={modal}'
export const APP_CMD_CHANGE_REGION_PATH = 'appcmd://change-region'

// SURVEY
export const SURVEY_REPORT_PATH = 'surveys/{tokenId}'
// REQUEST PHOTOS
export const REQUEST_PHOTOS_TOKEN_PATH = 'requestPhotos/{tokenId}'
export const REQUEST_PHOTOS_IMAGE_PATH = 'requestPhotos/{tokenId}/image'

// SETTINGS
export const SETTINGS_UPDATE_USER_PROFILE = 'estimates/user/settings'
export const SETTINGS_GET_USER_PROFILE = 'estimates/user/settings'
//IMAGES
export const IMAGES_DOWNLOAD_ZIP_PATH = 'images/zip'

// VEHICLE EVENTS
export const VEHICLE_EVENTS_BASE_PATH = 'vehicleEvents'
export const VEHICLE_EVENTS_TOKEN_PATH = 'vehicleEvents/login/{tokenId}'
export const VEHICLE_EVENTS_SEARCH_PATH = 'vehicleEvents/lookup'
export const VEHICLE_EVENT_PATH = 'vehicleEvents/{vehicleEventId}'
export const VEHICLE_EVENT_VEHICLE_FILE_PATH =
  'vehicleEvents/{vehicleEventId}/vehicleFile'
export const VEHICLE_EVENT_BOOKING_PATH =
  'vehicleEvents/{vehicleEventId}/booking'
export const VEHICLE_EVENT_BOOKING_LOOKUP_PATH =
  'vehicleEvents/{vehicleEventId}/booking/lookup'
export const VEHICLE_EVENT_SCHEMA_SIGNATURE_SVG_PATH =
  'vehicleEvents/{vehicleEventId}/schema/{schemaId}/signature/{number}'
export const VEHICLE_EVENT_ITEM_SIGNATURE_SVG_PATH =
  'vehicleEvents/{vehicleEventId}/schema/{schemaId}/items/{itemId}/signature'
export const CREATE_VEHICLE_EVENT_REPAIR_PATH =
  'vehicleEvents/repairfrom/{vehicleEventId}'
export const UPDATE_VEHICLE_EVENT_REPAIR_PATH =
  'vehicleEvents/repair/{vehicleEventId}'
export const CANCEL_VEHICLE_EVENT_REPAIR_PATH =
  'vehicleEvents/repair/{vehicleEventId}'
export const VEHICLE_EVENT_NEW_INITIATED_EVENT_PATH =
  'vehicleEvents/newinitiatedevent?vehicleId={vehicleId}'

export const VEHICLE_PLATE_OCR_PATH = 'vehicles/plateocr'
export const VEHICLE_EVENT_NEW_INITIATED_BY_REG_CODE_EVENT_PATH =
  'vehicleEvents/newinitiatedevent?regCode={regCode}'
